// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CollapseButton_wrapper__3CF_4","left":"CollapseButton_left__1sV-J","rotate":"CollapseButton_rotate__aH3mn"};